import React from "react";
import { useConfigurations } from "../../hooks";
import ACLStore from "lib/aclStore";
import { ENABLE_CONFIGURATION_FETCHING_OPTIMISATION } from "Constants/permissionConstants";
import { getDisplayName } from "Utils/HOCHelpers";

const WithConfigurations = hocConfiguration => Component => {
  function SetupConfigurations(props) {
    const shouldSkipQuery =
      hocConfiguration?.skip?.(props) ||
      !ACLStore.can(ENABLE_CONFIGURATION_FETCHING_OPTIMISATION);

    const { variables, fetchPolicy = "cache-and-network" } = !shouldSkipQuery
      ? hocConfiguration.options(props)
      : {};

    const configurationKey =
      hocConfiguration.getConfigurationKey?.(props) ?? "NOT_DEFINED";

    const { data, loading } = useConfigurations({
      variables,
      fetchPolicy,
      skip: shouldSkipQuery,
      configurationKey,
      configurationKeys: hocConfiguration.getConfigurationKeys?.(props) ?? [
        configurationKey,
      ],
    });
    if (shouldSkipQuery) {
      return <Component {...props} />;
    }

    const derivedProps = hocConfiguration.props
      ? hocConfiguration.props({ ownProps: props, data })
      : {};

    const isLoading = loading || props.isLoading;

    const isData = !!data && props.isData;

    return (
      <Component
        {...props}
        {...derivedProps}
        isLoading={isLoading}
        isData={isData}
      />
    );
  }

  SetupConfigurations.displayName = `WithConfigurations(${getDisplayName(
    Component
  )})`;

  return SetupConfigurations;
};

export default WithConfigurations;
